import React, { Component } from 'react';
import { Grid, Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import '../CSS/Settings.css';
import { getRemoteReservationsStatus, updateRemoteReservationsStatus, saveParkMap, getParkMapURL, deleteParkMap, updateReservationFields, getReservationFields } from '../utils/OpenCampground_Database_Calls';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const useStyles = theme => ({
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class SystemOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            remote: null,
            remoteReservationPaymentConfig: null,
            open: false,
            popupTitle: '',
            popupText: '',
            selectedImage: null,
            mapURL: null,
            imageFileName: null,
            useSeasonal: false,
            seasonStart: null,
            seasonEnd: null,
            useVariable: false,
            fields: {
                // startDate: false,
                // endDate: false,
                adults: false,
                children: false,
                pets: false,
                rigLength: false,
                siteType: false,
                rigType: false,
                siteLength: false,
                boatLength: false,
                boatDraft: false,
                boatBeam: false,
                freshWaterNeeds: false,
                pumpOutService: false,
                boatType: false,
                powerRequirement1: false,
                powerRequirement2: false,
              },
            requiredFields: {
                startDate: true,
                endDate: true, 
            },
        };
    }

    async componentDidMount() {
        let remoteActive = await getRemoteReservationsStatus(this.props.user, this.props.serverName);
        console.log(remoteActive[0])
        this.getMapURL();
        if (remoteActive[0].use_remote_reservations === 1) {
            let paymentConfig;
            if (remoteActive[0].require_gateway === 1) {
                paymentConfig = "require";
            } else if (remoteActive[0].allow_gateway === 1) {
                paymentConfig = "allow";
            } else {
                paymentConfig = "doNotAllow";
            }
            this.setState({
                remote: true,
                remoteReservationPaymentConfig: paymentConfig,
                useSeasonal: remoteActive[0].use_seasonal === 1 ? true : false,
                seasonStart: remoteActive[0].use_seasonal === 1 ? dayjs(remoteActive[0].season_start) : null,
                seasonEnd: remoteActive[0].use_seasonal === 1 ? dayjs(remoteActive[0].season_end) : null,
                useVariable: remoteActive[0].use_variable_charge === 1 ? true : false
            });
        } else {
            this.setState({
                remote: false,
                remoteReservationPaymentConfig: "require",
                useSeasonal: remoteActive[0].use_seasonal === 1 ? true : false,
                seasonStart: remoteActive[0].use_seasonal === 1 ? dayjs(remoteActive[0].season_start) : null,
                seasonEnd: remoteActive[0].use_seasonal === 1 ? dayjs(remoteActive[0].season_end) : null,
                useVariable: remoteActive[0].use_variable_charge === 1 ? true : false
            });
        }
        this.getReservationFields();
    }

    getReservationFields = async () => {
        try {
            const response = await getReservationFields(this.props.user, this.props.serverName);
            console.log(response+'getreservarion fe');
            // if (response && response.length) {
                if (response) {const apiFields = response;
                
                const updatedFields = {
                    adults: !!apiFields.use_guest,
                    children: !!apiFields.use_children,
                    pets: !!apiFields.use_pets,
                    rigLength: !!apiFields.use_rig_length,
                    siteType: !!apiFields.use_site_type,
                    rigType: !!apiFields.use_rig_type,
                    siteLength: !!apiFields.use_length,
                    powerRequirement1: !!apiFields.use_power1,
                    powerRequirement2: !!apiFields.use_power2,
                    boatLength: !!apiFields.use_boat_length,
                    boatDraft: !!apiFields.use_boat_draft,
                    boatBeam: !!apiFields.use_boat_beam,
                    freshWaterNeeds: !!apiFields.use_fresh_water,
                    pumpOutService: !!apiFields.use_pump_out,
                    boatType: !!apiFields.use_boat_type,
                    // startDate: !!apiFields.use_start_date,
                    // endDate: !!apiFields.use_end_date,
                };
    
                const updatedRequiredFields = {
                    startDate: !!apiFields.use_start_date,
                    endDate: !!apiFields.use_end_date,
                    ...(apiFields.required_fields || []).reduce((acc, field) => {
                        acc[field] = true;
                        return acc;
                    }, {})

                };
                console.log(JSON.stringify(updatedRequiredFields)+'required fiels reduce');
    
                // Update state
                this.setState({
                    fields: updatedFields,
                    requiredFields: updatedRequiredFields
                });
            }
        } catch (error) {
            console.error("Error fetching reservation fields:", error);
        }
    };
    
    handleFieldChange = (field) => {
        this.setState((prevState) => {
          const updatedFields = { ...prevState.fields };
          const updatedRequiredFields = { ...prevState.requiredFields };
    
          // Handle mutually exclusive power requirements
          if (field === "powerRequirement1") {
            updatedFields["powerRequirement2"] = false;
            delete updatedRequiredFields["powerRequirement2"];
          } else if (field === "powerRequirement2") {
            updatedFields["powerRequirement1"] = false;
            delete updatedRequiredFields["powerRequirement1"];
          }
    
          // Toggle field selection
          updatedFields[field] = !updatedFields[field];
    
          // If unchecked, remove it from requiredFields
          if (!updatedFields[field] && field !== "startDate" && field !== "endDate") {
            delete updatedRequiredFields[field];
          }
    
          return { fields: updatedFields, requiredFields: updatedRequiredFields };
        });
    };
    
    handleRequiredChange = (field) => {
        this.setState((prevState) => {
          const updatedRequiredFields = { ...prevState.requiredFields };
    
          if (updatedRequiredFields[field]) {
            delete updatedRequiredFields[field];
          } else {
            updatedRequiredFields[field] = true;
          }
    
          return { requiredFields: updatedRequiredFields };
        });
    };

    getMapURL = async () => {
        let getMapURL = await getParkMapURL(this.props.user, this.props.serverName)
        this.setState({
            mapURL: getMapURL.body.imageUrl,
            imageFileName: getMapURL.body.fileName
        });
    }

    saveFields = async () => {
        console.log(this.state.useVariable ? 1 : 0)
        let saveresponse = await updateReservationFields(this.props.user, this.props.serverName, this.state.fields.adults, this.state.fields.children, this.state.fields.pets,
            this.state.fields.rigLength, this.state.fields.siteType, this.state.fields.rigType, this.state.fields.siteLength, this.state.fields.powerRequirement1, this.state.fields.powerRequirement2,
            this.state.fields.boatLength, this.state.fields.boatDraft, this.state.fields.boatBeam, this.state.fields.freshWaterNeeds, this.state.fields.pumpOutService, this.state.fields.boatType,
            JSON.stringify(Object.keys(this.state.requiredFields))
        );
        console.log("saveresponse: ", saveresponse)
        this.setState({
            popupTitle: 'System Options',
            popupText: 'Choices have been saved successfully.',
            open: true
        });
    };

    saveSystemOptions = async () => {
        console.log(this.state.useVariable ? 1 : 0)
        let saveresponse = await updateRemoteReservationsStatus(this.props.user, this.props.serverName, this.state.remote, this.state.remoteReservationPaymentConfig,
            this.state.useSeasonal, this.state.seasonStart === null ? null : this.state.seasonStart.format("YYYY-MM-DD"),
            this.state.seasonEnd === null ? null : this.state.seasonEnd.format("YYYY-MM-DD"), this.state.useVariable
        );
        console.log("saveresponse: ", saveresponse)
        this.setState({
            popupTitle: 'System Options',
            popupText: 'System options updated successfully.',
            open: true
        });
    };

    handleCancel = () => {
        this.setState({ open: false });
    };

    handleChange = (event) => {
        if (event.target.id === 'remote') {
            this.setState({
                [event.target.id]: event.target.checked
            });
        } else if (event.target.id === 'useSeasonal') {
            this.setState({
                [event.target.id]: event.target.checked,
                seasonStart: event.target.checked ? this.state.seasonStart : null,
                seasonEnd: event.target.checked ? this.state.seasonEnd : null
            });
        } else {
            this.setState({
                [event.target.id]: event.target.checked,
            })
        }
    };

    isRadioChecked = (value) => {
        return this.state.remoteReservationPaymentConfig === value;
    };

    handleImageChange = (event) => {
        const file = event.target.files[0];
        this.setState({
            selectedImage: file,
        });
    };

    uploadParkMap = async () => {
        let imageUploadStatus = await saveParkMap(this.props.user, this.props.serverName, this.state.selectedImage)
        if (imageUploadStatus.statusCode === 200) {
            this.setState({
                popupTitle: 'Park Map',
                popupText: 'Park map has been uploaded successfully.',
                open: true
            })
            this.getMapURL();
        } else {
            this.setState({
                popupTitle: 'Park Map',
                popupText: 'Park map cannot be uploaded. Please try again.',
                open: true
            })
        }
    };

    deleteMap = async () => {
        let deleteResponse = await deleteParkMap(this.props.user, this.props.serverName, this.state.imageFileName)
        console.log(deleteResponse)
        this.setState({
            mapURL: null,
            imageFileName: null,
            popupTitle: 'Park Map',
            popupText: 'Park map deleted successfully.',
            open: true
        })
    }

    render() {
        const { classes } = this.props;
        return (
            <>
                <ThemeProvider theme={theme}>
                    <Dialog open={this.state.open} onClose={this.handleCancel} classes={{ paper: classes.dialogPaper }}>
                        <DialogTitle>{this.state.popupTitle}</DialogTitle>
                        <DialogContent>
                            {this.state.popupText}
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <div className='paymentConfig' style={{ width: '90%', marginLeft: '2%', marginBottom: '2%' }}>
                        <div className='row' >
                            <Typography style={{ fontSize: '1.3rem' }}>Manager Reservations Settings</Typography>
                        </div>
                        <div className='row'>
                            <FormControlLabel
                                label={"Use Seasonal rates"}
                                control={
                                    <Checkbox
                                        id="useSeasonal"
                                        checked={this.state.useSeasonal}
                                        onChange={this.handleChange}
                                    />
                                }
                            />
                            <FormControlLabel
                                label={"Use variable charges"}
                                control={
                                    <Checkbox
                                        id="useVariable"
                                        checked={this.state.useVariable}
                                        onChange={this.handleChange}
                                    />
                                }
                            />
                        </div>
                        {this.state.useSeasonal &&
                            <>
                                <div style={{ display: 'flex', justifyContent: 'left', gap: '2%' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            id="seasonStart"
                                            label="Seasonal Start"
                                            value={this.state.seasonStart}
                                            onChange={(date) => {
                                                this.setState({ seasonStart: date });
                                            }}
                                        />
                                    </LocalizationProvider>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            id="seasonEnd"
                                            label="Seasonal End"
                                            value={this.state.seasonEnd}
                                            minDate={dayjs(this.state.seasonStart).add(1, "day")}
                                            onChange={(date) => {
                                                this.setState({ seasonEnd: date });
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </>
                        }
                    </div>

                    <div className='paymentConfig' style={{ width: '90%', marginLeft: '2%' }}>
                        <div className='row'>
                            <Typography style={{ fontSize: '1.3rem' }}>Online Reservations Settings</Typography>
                        </div>
                        <div className='row'>
                            <FormControlLabel
                                label={"Allow Online Reservations"}
                                control={
                                    <Checkbox
                                        id="remote"
                                        checked={this.state.remote}
                                        onChange={this.handleChange}
                                    />
                                }
                            />
                        </div>
                        {this.state.remote &&
                            <>
                                <div className='row' style={{ marginLeft: '-1%' }}>
                                    <label>
                                        <Radio
                                            name='option'
                                            value='require'
                                            checked={this.isRadioChecked('require')}
                                            onChange={() => { this.setState({ remoteReservationPaymentConfig: 'require' }) }}
                                        />
                                        Online Reservations Require Payment
                                    </label>
                                    <label>
                                        <Radio
                                            name='option'
                                            value='allow'
                                            checked={this.isRadioChecked('allow')}
                                            onChange={() => { this.setState({ remoteReservationPaymentConfig: 'allow' }) }}
                                        />
                                        Online Reservations Allow Payment
                                    </label>
                                    <label>
                                        <Radio
                                            name='option'
                                            value='doNotAllow'
                                            checked={this.isRadioChecked('doNotAllow')}
                                            onChange={() => { this.setState({ remoteReservationPaymentConfig: 'doNotAllow' }) }}
                                        />
                                        Online Reservations do not use Payment (Pay at time of checkIn)
                                    </label>
                                </div>
                                <div className='row'>
                                    <Typography style={{ textAlign: 'left', width: '100%' }}>
                                        Use this URL (
                                        <a
                                            href={`https://www.app.opencampground.com/remote?serverName=${this.props.serverName}`}
                                            target="_blank"
                                            // rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: 'blue' }}
                                        >
                                            {`https://www.app.opencampground.com/remote?serverName=${this.props.serverName}`}
                                        </a>
                                        ) for Online Reservations. Please see our knowledge base for instructions.
                                    </Typography>
                                </div>
                            </>
                        }
                    </div>

                    <div style={{ width: '90%', marginLeft: '2%', display: 'flex', justifyContent: 'left' }}>
                        <Button style={{ backgroundColor: '#2dcd7a', color: '#000000', marginTop: '3%' }} className='viewButtons' onClick={this.saveSystemOptions}>Save</Button>
                    </div>

                    <div className='paymentConfig' style={{ width: '90%', marginLeft: '2%', marginTop:'2%' }}>
                        <div className='row'>
                            <Typography style={{ fontSize: '1.3rem' }}>Online Reservation Fields</Typography>
                        </div>
                        <div className="row" style={{ 
                            display: "grid", 
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "20px", 
                            alignItems: "center"
                            }}
                        >
                            {Object.keys(this.state.fields).map((field) => (
                            <div key={field} style={{ display: "flex", alignItems: "center" }}>
                                <FormControlLabel
                                label={field
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, (str) => str.toUpperCase())
                                    .replace("Power Requirement1", "Power Requirements (15, 30, 50 amp)")
                                    .replace("Power Requirement2", "Power Requirements (30/50/100 amp)")}
                                    control={
                                    <Checkbox
                                    checked={this.state.fields[field]}
                                    onChange={() => this.handleFieldChange(field)}
                                    />}
                                />
                                {this.state.fields[field] && (
                                <FormControlLabel
                                label="Required"
                                control={
                                <Checkbox
                                checked={field === "startDate" || field === "endDate" || !!this.state.requiredFields[field]}
                                onChange={() => this.handleRequiredChange(field)}
                                />}
                                />
                                )}
                            </div>
                        ))}
                        </div>
                    </div>

                    <div style={{ width: '90%', marginLeft: '2%', display: 'flex', justifyContent: 'left' }}>
                        <Button style={{ backgroundColor: '#2dcd7a', color: '#000000', marginTop: '3%' }} className='viewButtons' onClick={this.saveFields} >Save Fields</Button>
                    </div>

                    <hr style={{ width: '90%', border: '1px solid rgba(159, 159, 159, 255)', margin: '2% 0 2% 2%' }} />
                    {this.state.mapURL === null
                        ?
                        <div style={{ width: '90%', marginLeft: '2%' }}>
                            <Typography style={{ fontSize: '1.3rem', marginBottom: '1rem', textAlign: 'left' }}>Upload Park Map</Typography>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                <input type="file" accept="image/*" onChange={this.handleImageChange} />
                                <Button
                                    style={{ backgroundColor: '#2dcd7a', color: '#000000' }}
                                    onClick={this.uploadParkMap}
                                >
                                    Upload Image
                                </Button>
                            </div>
                        </div>
                        :
                        <div style={{ width: '90%', marginLeft: '2%' }}>
                            <Typography style={{ fontSize: '1.3rem', marginBottom: '1rem', textAlign: 'left' }}>You have alread uploaded a site map</Typography>
                            <div style={{ display: 'flex', justifyContent: 'left' }}>
                                <Button style={{ backgroundColor: '#2dcd7a', color: '#000000' }} onClick={() => window.open(this.state.mapURL, '_blank')}>View Map</Button>
                                <Button style={{ backgroundColor: '#2dcd7a', color: '#000000', marginLeft: '2%' }} onClick={this.deleteMap}>Delete Map</Button>
                            </div>
                        </div>
                    }
                </ThemeProvider>
            </>
        );
    }
}

export default withStyles(useStyles)(SystemOptions);